<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

   let xLabel = ['1', '2', '3', '4', '5', '6'];
   let goToSchool = ['40', '60', '22', '85', '50', '40'];
   let goOutSchool = ['20', '50', '12', '65', '30', '60'];

    this.state.chart.setOption({
      // color: ['#136E78', '#136E78', '#136E78', '#136E78'],
         tooltip: {
            trigger: 'axis',
            // formatter: (params) => {
            //     // console.log('params',params)
            //     let str = `${params[0].name}月<br/>`;
            //     //seriesName color value
            //     for (let i = 0; i < params.length; i++) {
            //         str =
            //             str +
            //             `<span style='display:inline-block;margin-right:5px;
            //         border-radius:10px;width:9px;height:9px;background-color:${params[i].color}'></span>
            //         ${params[i].seriesName}：<i style='float:right;color:#136E78 ' >${params[i].value}吨</i><br/>`;
            //     }
            //     return str;
            // },
         },
         legend: {
            show:false,
         },
         grid: {
            top: '15%',
            left: '10%',
            right: '10%',
            bottom: '18%',
            // containLabel: true
         },
         xAxis: [
            {
               type: 'category',
               name: '月',
               nameGap: 10,
               boundaryGap: false,
               nameTextStyle: {
                  // ---坐标轴名称样式
                  color: '#fff',
                  fontSize: 12,
               },
               axisLabel: {
                  show: true,
                  interval: 0, //横轴信息全部显示
                  // rotate:-30,//-30度角倾斜显示
                  color: '#E2E8EDE8', // 更改坐标轴文字颜色
                  fontSize: this.screenScale * 15, // 更改坐标轴文字大小
               },
               splitLine: {
                  show: true,
                  lineStyle: {
                     type: 'solid',
                     // dashOffset: 0,
                     color: 'rgba(0,176,255,.1)',
                     width: 2
                  }
               },
               axisLine: {
                  show: true,
                  lineStyle: {
                     color: 'rgba(0,176,255,.1)',
                  },
               },
               axisTick: {
                  show: false,
               },
               data: xLabel,
            },
         ],
         yAxis: [
            {
               name:"吨",
               nameTextStyle: {
                  color: '#5093B8',
                  fontSize: 12,
               },
            axisLabel: {//y轴文字的配置
               color: "#5093B8",
               margin: 15
            },
               splitLine: {
                  show: true,
                  lineStyle: {
                     type: 'solid',
                     color: '#042F42',
                     width:2
                  }
               },
            },
         ],
         series: [
            {
                  name: '食品',
                  type: 'line',
                  symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
                  showAllSymbol: true,
                  symbolSize: 0,
                  smooth: true,
                  lineStyle: {
                     width: 3,
                     borderColor: 'rgba(0,0,0,.4)', 
                  },
                  itemStyle: {
                     borderColor: '#646ace',
                     borderWidth: 3,
                     color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                           {
                           offset: 0,
                           color: 'rgb(20, 216, 237, 0)'
                           },
                           {
                           offset: 0.1,
                           color: 'rgb(2, 120, 237, 0)'
                           },
                           {
                           offset: 0.4,
                           color: 'rgb(2, 120, 237, 80)'
                           },
                           {
                           offset: 0.6,
                           color: 'rgb(2, 120, 237, 80)'
                           },
                           {
                           offset: 0.9,
                           color: 'rgb(2, 120, 237, 0)'
                           },
                           {
                           offset: 1,
                           color: 'rgb(2, 120, 237, 0)'
                           }
                     ])
                  },
                  tooltip: {
                     show: true,
                  },
                  data: goToSchool,
            },
            {
                  name: '日用品',
                  type: 'line',
                  symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
                  showAllSymbol: true,
                  symbolSize: 0,
                  smooth: true,
                  lineStyle: {
                     width: 3,
                     borderColor: 'rgba(0,0,0,.4)',
                  },
                  itemStyle: {
                     borderColor: '#646ace',
                     borderWidth: 3,
                     color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                           {
                           offset: 0,
                           color: 'rgb(1, 248, 249, 0)'
                           },
                           {
                           offset: 0.1,
                           color: 'rgb(1, 248, 249, 0)'
                           },
                           {
                           offset: 0.4,
                           color: 'rgb(1, 248, 249, 80)'
                           },
                           {
                           offset: 0.6,
                           color: 'rgb(1, 248, 249, 80)'
                           },
                           {
                           offset: 0.9,
                           color: 'rgb(1, 248, 249, 0)'
                           },
                           {
                           offset: 1,
                           color: 'rgb(1, 248, 249, 0)'
                           }
                     ])
                  },
                  tooltip: {
                     show: true,
                  },
                  data: goOutSchool,
            },
         ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
